import React from 'react';
import cx from 'classnames';

import { Mincult, NationalProjects } from 'components/Logos';
import Navigation from 'components/Navigation';

import styles from './styles.module.scss';

const dataNavigationSimple = [
	{
		title: 'О проекте',
		url:
			'/materials/74852/portal-kulturnogo-naslediya-i-traditsiy-rossii-kultura-rf'
	},
	{
		title: 'Открытые данные',
		url: 'http://opendata.mkrf.ru/',
		target: '_blank',
		rel: 'noopener'
	}
];

const About = () => (
	<div className={styles.About}>
		<div className={styles.About__GroupLogo}>
			<div className={styles.About__Figure}>
				<Mincult
					className={cx(styles.About__Logo, styles.About__Logo_primary)}
				/>
			</div>
			<div className={styles.About__Figure}>
				<NationalProjects
					className={cx(styles.About__Logo, styles.About__Logo_primary)}
				/>
			</div>
		</div>
		<div className={styles.About__Content}>
			<div className={styles.About__Text}>
				«Культура.РФ» — гуманитарный просветительский проект, посвященный
				культуре России. Мы рассказываем об интересных и значимых событиях и
				людях в истории литературы, архитектуры, музыки, кино, театра, а также о
				народных традициях и памятниках нашей природы в формате просветительских
				статей, заметок, интервью, тестов, новостей и в любых современных
				интернет-форматах.
			</div>
			<Navigation
				primacy="simple"
				data={dataNavigationSimple}
				parentTabIndex={0}
			/>
		</div>
	</div>
);

export default About;
